"use client";

import { AnimateOnScroll, StaggeredList } from "./index";

const principles = [
  {
    number: "01",
    title: "Specs First, Code Second",
    description:
      "Define behavior, constraints, and success criteria. Implementation derives from specifications - divergence is tracked and surfaced.",
  },
  {
    number: "02",
    title: "Every Change Leaves a Trail",
    description:
      "Modifications produce traceable deltas. Checkpoints capture alignment points for informed branching.",
  },
  {
    number: "03",
    title: "Humans Steer, AI Executes",
    description:
      "Full visibility and control at every decision point. AI handles implementation within human-defined intent.",
  },
  {
    number: "04",
    title: "Context Compounds",
    description:
      "Sessions are indexed, specs are versioned. Organizational knowledge grows with every interaction.",
  },
];


export function Principles() {
  return (
    <section id="how-it-works" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-bg-alt">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <AnimateOnScroll variant="fade-up" className="text-center max-w-[640px] mx-auto mb-8 sm:mb-12 md:mb-16">
          <span className="inline-block text-[10px] sm:text-xs font-semibold text-primary uppercase tracking-[1.5px] mb-3 sm:mb-4">
            Core Principles
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight mb-3 sm:mb-4 text-text">
            Spec-Driven Development
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-text-muted leading-relaxed">
            Four principles that ensure your code always reflects your intent.
          </p>
        </AnimateOnScroll>

        {/* Principles Grid */}
        <StaggeredList
          className="flex flex-col gap-3 sm:gap-4 md:gap-5 max-w-[900px] mx-auto"
          staggerDelay={120}
          duration={500}
        >
          {principles.map((principle) => (
            <div
              key={principle.number}
              className="bg-white border border-border rounded-xl sm:rounded-2xl px-4 py-4 sm:px-6 sm:py-5 md:px-8 md:py-7 flex flex-col sm:flex-row gap-3 sm:gap-5 md:gap-7 items-start transition-all duration-300 hover:border-primary hover:shadow-md"
            >
              <div className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-primary font-mono leading-none min-w-[40px] sm:min-w-[50px] md:min-w-[60px]">
                {principle.number}
              </div>
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-text mb-1.5 sm:mb-2">
                  {principle.title}
                </h3>
                <p className="text-xs sm:text-sm md:text-[15px] text-text-muted leading-relaxed">
                  {principle.description}
                </p>
              </div>
            </div>
          ))}
        </StaggeredList>
      </div>
    </section>
  );
}
